<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="类型名称" prop="CategoryName">
                <el-input size="small" v-model="model.CategoryName" auto-complete="off" placeholder="请输入中文" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="CategorySort">
                <el-input size="small" v-model.number="model.CategorySort" auto-complete="off" placeholder="请输入序号" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateDACategorylist
    } from '../../../api/device'
    export default {
        data() {
            return {
                title: '编辑应用类型',
                name: 'edit',
                labelwidth: '120px',
                labelPosition: 'right',
                baseURL: window.Global.baseURL,
                model: {
                    CategoryName:'',
                    OID: null,
                    CategorySort: null
                },
                rules: {
                    CategoryName: [{
                        required: true,
                        message: '类型名称不能为空',
                        trigger: 'blur'
                    }],
                    CategorySort: [{
                        required: true,
                        message: '序号不能为空',
                        trigger: 'blur',
                        type: 'number'
                    }],
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if (this.data) {
                    this.model = this.data;
                }
            },
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateDACategorylist()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateDACategorylist() {
                UpdateDACategorylist(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
        }
    }
</script>

<style>

</style>